<template>
  <ul class="sub-menu sub-menu-page navbar-nav pl-0">
    <router-link
      v-for="(menu,index) in menuJson[subMenuName]"
      v-if="checkPermission(menu)"
      :key="index"
      :to="{ path: menu.link }"
      :class="[{ active: $route.path.includes(menu.routeGlobal)}]"
      tag="li"
    >
      <menu-item
        :name="$t(menu.text)"
        :icon="menu.icon"
        :link="menu.link"
      />
    </router-link>
  </ul>
</template>
<script>
import menuJson from '@/components/app/user/partials/navbar/menu.json'
import MenuItem from './MenuItem.vue'
import { mapState } from 'vuex'
import MenuHeader from '@/components/app/user/partials/navbar/web/mainMenu/MenuHeader'

export default {
	name: 'sub-menu',
	components: { MenuItem, MenuHeader },
	props: {
		subMenuName: {
			type: String,
			default: null
		}
	},
	data () {
		return {
			menuJson: menuJson,
			activeshow: false
		}
	},
	computed: {
		...mapState('User', ['permissions', 'user'])
	},
	methods: {
		checkPermission (menu) {
			//  return true
			if (menu.permission) {
				let permission = this.permissions.find(
					perm => perm.permissionName === menu.permission.name
				)

				if (permission) {
					if (this.user.id === this.user.saasApp.adminId) return true
					let hasPermission = menu.permission.actions.some(action => permission.p[action])
					if (hasPermission) return true
				} else return false
			}

			let sub = menu.sub
			let exist = false
			if (!sub || sub.length < 1) return true

			if (sub.length > 0) {
				sub.map(s => {
					if (!s.permission) {
						exist = true
						return true
					}

					let permission = this.permissions.find(
						perm => perm.permissionName === s.permission.name
					)

					if (permission) {
						let hasPermission = s.permission.actions.some(action => permission.p[action])

						if (hasPermission) {
							exist = true
							return true
						}
					}
				})
				return exist
			}

			return false
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/app/user/partials/navbar/web/subMenu/index.vue